import useTranslator from "../../../hooks/useTranslator";

const AddDetailsAndId = (props) => {
  const { setCurrentScreen } = props;
  const { _t } = useTranslator();

  const handleChangeScreen = () => {
    setCurrentScreen("form");
  };

  return (
    <>
      <div className="big_tablebg tenant-doc-tile">
        <div className="border-pd">
          <ul>
            <li className="d-flex tile-design border-0 p-0 m-0">
              <div className="tile-content-wrapper">
                <img src="/images/verify-home-icon.svg" alt="" />
                <div className="tile-content">
                  <h4 className="tile-heading">
                    {_t(
                      "VerifyTenantIdAndDefaulterChecks",
                      "Landlord side tile heading while creating a new Tenant"
                    )}
                  </h4>

                  <p className="tile-desc-completed">
                    {_t(
                      "VerifyTenantIdAndDefaulterChecksDesc",
                      "Landlord side tile Description while creating a new Tenant"
                    )}
                  </p>
                </div>
                <div className="d-flex align-items-center gap-4 tile-btns-wrapper ms-auto">
                  <button onClick={handleChangeScreen} className="btn btngreen">
                    {_t("complete")}
                  </button>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default AddDetailsAndId;
